export default __webpack_public_path__ + "static/laptop-image-1c87db8c24fe99d9a89e35c8308dcd07.png";